import fetchMock from "fetch-mock";

fetchMock.config.fallbackToNetwork = true;

console.log("fetch mock enabled", fetchMock);
